export default __webpack_public_path__ + "static/media/KR.c2219b9c.svg";